import { useMemo } from "react";

import { InputAccessory, Lot } from "types";
import CRC32 from "crc-32";

/**
|--------------------------------------------------
| Use to check if the attribute value has a checksum match
|--------------------------------------------------
| @param lot - The lot to check
| @param attributeValue - The value of the attribute
| @param attributePath - The path of the attribute
| @returns The accessory if the attribute value has a checksum match, otherwise null 
|--------------------------------------------------
*/
export function useDisplayAccessory(
  lot: Lot,
  attributeValue: string,
  attributePath: string
) {
  const inputAccessories = useMemo(() => {
    const inputAccessories = lot?.inputAccessories;
    return findAccessoryByPath(inputAccessories, attributePath);
  }, [lot]);

  const doesChecksumMatchResult = useMemo(() => {
    return doesChecksumMatch(inputAccessories?.checksum || "", attributeValue);
  }, [inputAccessories, attributeValue]);

  return doesChecksumMatchResult ? inputAccessories : null;
}

export function findAccessoryByPath(
  inputAccessories:
    | {
        [id: string]: InputAccessory;
      }
    | undefined,
  attributePath: string
) {
  const objectValues = Object.values(inputAccessories || {});
  return objectValues.find((accessory) => {
    return accessory.path === attributePath;
  });
}

export function doesChecksumMatch(
  checksum: string | null | undefined,
  value: string | null | undefined
) {
  if (!checksum || !value) {
    return false;
  }
  const t = CRC32.str(value).toString();
  return t === checksum;
}
